export default __webpack_public_path__ + "static/media/back-arrow.73301e25.svg";